import { SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType } from '@src/core/enums';

const listeners = new Set<() => void>();

function readStoredUnitType(): UnitType {
  if (typeof window === 'undefined') return UnitType.SI;
  const stored = localStorage.getItem(SETTING_UNITS_KEY);
  if (stored === UnitType.SI || stored === UnitType.IMPERIAL) return stored;
  return UnitType.SI;
}

let currentUnitType: UnitType = readStoredUnitType();

export function getUnitType(): UnitType {
  return currentUnitType;
}

export function isUnitType(value: unknown): value is UnitType {
  return value === UnitType.SI || value === UnitType.IMPERIAL;
}

export function setUnitType(type: UnitType): void {
  if (!isUnitType(type) || currentUnitType === type) return;
  currentUnitType = type;
  localStorage.setItem(SETTING_UNITS_KEY, type);
  listeners.forEach((listener) => listener());
}

export function subscribeUnitType(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
